import { useSelector } from "react-redux";


const Banners = () => {
  const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        {/* <iframe title="htFrame" src= {`https://iipl.retool.com/embedded/public/a75b2213-6ee5-405e-82c6-faff9ab1c4a0`}
        className="iframe-style"></iframe> */}
        <iframe src= {`https://iiplwork.retool.com/embedded/public/0d39e057-4bea-46fb-a39d-9cee747196a8
        `}
        className="iframe-style"></iframe>
    </div>
  )
};

export default Banners;
